import Spinner from '@atlaskit/spinner';
import { useQuery } from '@tanstack/react-query';
import React, { FC } from 'react';
import EmptyState from '@atlaskit/empty-state';

import { useFetchErrorController } from '@/controllers';
import { apiFetch } from '@/services';
import { querySpec } from '@/services/api-service/api-queries';

import { detectorsStyles, spinnerStyles } from './styles';
import DetectorsTable from './detectors-table';

interface DetectorsProps {
  publicId: string;
}

const Detectors: FC<DetectorsProps> = ({ publicId }) => {
  const { onError } = useFetchErrorController();
  const { queryKey, path } = querySpec('detectormonitoring.slo.{id}', { id: publicId });
  const { data, isInitialLoading: isLoading } = useQuery(queryKey, () => apiFetch(path), {
    onError,
  });

  if (isLoading) {
    return (
      <div css={detectorsStyles}>
        <div css={spinnerStyles}>
          <Spinner size="small" />
        </div>
      </div>
    );
  }

  const detectors: any[] = data || [];

  return (
    <div css={detectorsStyles}>
      {detectors.length === 0 && (
        <EmptyState
          header="No detectors"
          description={<>This SLO has no detectors created in SignalFx</>}
          imageUrl="/assets/not-found.svg"
        />
      )}
      {detectors.length > 0 && <DetectorsTable detectors={detectors} title="" />}
    </div>
  );
};

export default Detectors;
